<div class="row align-items-start">
    <div class="col-12 col-lg-6">
        <app-dashboard-contributors-departments>
        </app-dashboard-contributors-departments>

        <app-spacer [bottom]="16"></app-spacer>
    </div>

    <div class="col-12 col-lg-6">
        <app-dashboard-contributors-collaborators>
        </app-dashboard-contributors-collaborators>

        <app-spacer [bottom]="16"></app-spacer>
    </div>

    <div class="col-12 col-lg-6">
        <app-dashboard-contributors-witnesses>
        </app-dashboard-contributors-witnesses>
    </div>
</div>